var React = require('react');

function Volume (props) {
    return React.createElement("svg",props,[React.createElement("polygon",{"points":"11 5 6 9 2 9 2 15 6 15 11 19 11 5","key":0}),React.createElement("path",{"d":"M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07","key":1})]);
}

Volume.defaultProps = {"width":"48","height":"48","viewBox":"0 0 24 24","fill":"none","stroke":"#000","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"};

module.exports = Volume;

Volume.default = Volume;
